import { createContext, type ReactNode } from "react";
import type { SchedulesManager } from "@/pages/human-resources/time-management/business/SchedulesManager.ts";
import { ScheduleReferenceDataStateContext } from "@/pages/human-resources/time-management/schedules/reference-provider/ScheduleReferenceDataStateProvider.tsx";
import useDefinedContextValue from "@/shared/custom-hook/useDefinedContextValue.ts";
import useScheduleManagerLoader from "@/pages/human-resources/time-management/schedules/site-schedule/model/schedule-data/useScheduleManagerLoader.ts";

// eslint-disable-next-line react-refresh/only-export-components
export const SchedulesManagerContext = createContext<
  SchedulesManager | undefined
>(undefined);

export default function SchedulesManagerProvider(props: {
  children: ReactNode;
}): ReactNode {
  const { site } = useDefinedContextValue(ScheduleReferenceDataStateContext);
  const scheduleManager = useScheduleManagerLoader(site);
  return scheduleManager === undefined ? undefined : (
      <SchedulesManagerContext.Provider value={scheduleManager}>
        {props.children}
      </SchedulesManagerContext.Provider>
    );
}
